import { Grid } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { IsSmallScreen, TransactionPages } from "../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { Header } from "../../Components/Header/Header";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";

export const QuoteList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit, view, add } = getPermissions(TransactionPages.Quotations);
  const isMobile = IsSmallScreen();
  const source = {
    url: "quotations/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [{
        "field": "UptedAt",
        "direction": "desc"
      }]
  };

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/quatation/${row?.id}`);
    } else if (action === "Delete") {
    } else if (action === "Print") {
      navigate(`/quatation/print/${row?.id}`);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Customer Name",
      fieldName: "customerName",
      tooltip: true
    },

    {
      header: "Date",
      fieldName: "date",
      tooltip: true
    },
    {
      header: "Subject",
      fieldName: "subject",
      tooltip: true
    },
    {
      header: "Expiry Date",
      fieldName: "validTill",
      tooltip: true
    },

    {
      header: "Grand Total",
      fieldName: "grandTotal",
      tooltip: true
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, "Delete", "Print"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Customer Name",
      fieldName: "customerName",
      tooltip: true
    },

    {
      header: "Date",
      fieldName: "date",
      tooltip: true
    },
    {
      header: "Subject",
      fieldName: "subject",
      tooltip: true
    },
    {
      header: "Expiry Date",
      fieldName: "validTill",
      tooltip: true
    },

    {
      header: "Grand Total",
      fieldName: "grandTotal",
      tooltip: true
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, "Delete", "Print"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  const handleClick = () => {
    navigate("/quatation");
  };

  return (
    <>
      <Header
        type="light"
        isDivider={true}
        title="New Quote"
        id={"newquoteHeader"}
      />
      <Grid container spacing={2}>
        {view ? <Grid item xs={12}>
          {!isMobile && <WSDataGrid
            id="newquoteGrid"
            title="New Quote33"
            columns={columns}
            source={source}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          />}
          {isMobile &&
            <WSMobileDataGridAdvanced title={'New Estimation'} addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick} columns={mobColumns} id="estimationGrid" source={source} />
          }
        </Grid>
          : <PermissionDenied />}
      </Grid>
    </>
  );
});
